import { getStoreId } from "$/hooks/use-store-information"
import serviceEventQueries from "$/lib/queries/service-event-queries"
import storeQueries from "$/lib/queries/store-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/event/$eventId/edit")({
  loader: async ({ context: { queryClient }, params: { eventId } }) => {
    const storeId = await getStoreId()
    if (storeId) {
      queryClient.prefetchQuery(storeQueries.detail(storeId))
      queryClient.prefetchQuery(serviceEventQueries.detail(eventId))
    }
    return {
      crumb: "alfred.pages.event.crumbs.edit",
    }
  },
})
